import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContextSystem } from '@wp-g2/context';
import { css, cx, useResponsiveValue } from '@wp-g2/styles';
import * as styles from './Container.styles';
export function useContainer(props) {
  var _useContextSystem = useContextSystem(props, 'Container'),
      _useContextSystem$ali = _useContextSystem.alignment,
      alignment = _useContextSystem$ali === void 0 ? 'center' : _useContextSystem$ali,
      className = _useContextSystem.className,
      _useContextSystem$wid = _useContextSystem.width,
      width = _useContextSystem$wid === void 0 ? 1280 : _useContextSystem$wid,
      otherProps = _objectWithoutProperties(_useContextSystem, ["alignment", "className", "width"]);

  var maxWidth = useResponsiveValue(width);
  var classes = cx(css({
    maxWidth: maxWidth,
    width: '100%'
  }), styles[alignment], className);
  return _objectSpread(_objectSpread({}, otherProps), {}, {
    className: classes
  });
}